import React from 'react';

//@ts-ignore
import * as styles from './filtered-content.module.css';
import { ContentPreview } from './index';
import { FilteredContentProps } from './index';
import { getMultiChoice, getTimeToRead } from '../Global/DataUtils';
import { BlogPagePreview } from '../Global/DataUtils/blogQueries';
import BlogSubscriptionForm from '../Global/BlogSubscriptionForm';
import CtaLink from '../Global/CtaLink';
import { getFluidImageData } from '../Global/DataUtils/gatsbyImageUtils';
import GatsbyImage from 'gatsby-image';
import { KontentGatsbyTransformerImage } from '../../../types/KontentProps';

interface Props {
    content?: ContentPreview[];
    show_blog_subscription_form: FilteredContentProps['show_blog_subscription_form'];
    cta_label: FilteredContentProps['cta_label'];
    submit_cta_label: FilteredContentProps['submit_cta_label'];
    interested_in_field: FilteredContentProps['interested_in_field'];
    full_name_field: FilteredContentProps['full_name_field'];
    form_headline: FilteredContentProps['form_headline'];
    email_address_field: FilteredContentProps['email_address_field'];
    blog_topic: FilteredContentProps['blog_topic'];
    form_confirmation_message: FilteredContentProps['form_confirmation_message'];
}

const BlogExploration: React.FC<Props> = ({
    content,
    cta_label,
    show_blog_subscription_form,
    submit_cta_label,
    interested_in_field,
    full_name_field,
    form_headline,
    email_address_field,
    blog_topic,
    form_confirmation_message,
}) => {
    const renderPost = (contentItem: BlogPagePreview, contentIdx: number) => {
        const metadata =
            contentItem?.elements?.other_metadata?.value[0]?.elements;

        if (!metadata) {
            return null;
        }

        const url = contentItem?.elements.slug.url;
        const relatedTags = contentItem?.elements.blog_topic.value;
        const timeToRead = getTimeToRead(contentItem as BlogPagePreview);

        const renderImages = () => {
            const exploreAllBlogsImages =
                metadata?.explore_all_blogs_image?.value;

            let images: {
                [key: string]: any;
                alt?: string;
            } = {};

            exploreAllBlogsImages?.map((image) => {
                const imageData = image.elements?.file?.value[0];

                if (!imageData) return null;

                const imageWidth = imageData.width;

                if (imageData.fluid && imageWidth && imageWidth > 360) {
                    images.large = imageData.fluid;
                    images.alt = imageData.description || imageData.name;
                }

                if (imageData.fluidShort && imageWidth && imageWidth < 361) {
                    images.small = imageData.fluidShort;
                }
            });

            if (!images.large) return null;

            const sources = images.small
                ? [
                      {
                          ...images.small,
                          media: '(max-width: 576px)',
                      },
                      {
                          ...images.large,
                          media: '(min-width: 577px)',
                      },
                  ]
                : images.large;

            return (
                <GatsbyImage
                    //@ts-ignore
                    fluid={sources}
                    alt={images.alt}
                />
            );
        };

        return (
            <React.Fragment key={contentIdx}>
                <div className={styles.blogExploration}>
                    <div className={styles.featuredImage}>
                        {renderImages()}
                        {relatedTags && (
                            <span className={styles.relatedTags}>
                                {relatedTags.map((tag, tagIdx) => (
                                    <span
                                        className={styles.relatedTag}
                                        key={tagIdx}
                                    >
                                        {tag.name}
                                    </span>
                                ))}
                            </span>
                        )}
                    </div>
                    <div className={styles.blogContent}>
                        {timeToRead > 0 && (
                            <p className={styles.minuteReadTime}>
                                {timeToRead} minute read
                            </p>
                        )}
                        <div className={styles.blogTitle}>
                            {metadata?.title.value}
                        </div>
                        <p>{metadata?.short_description.value}</p>
                        <CtaLink href={url} target="_self" color="#505251">
                            {cta_label?.value}
                        </CtaLink>
                    </div>
                </div>
            </React.Fragment>
        );
    };
    const blogFormShow =
        getMultiChoice(show_blog_subscription_form) === 'yes' &&
        form_headline?.value;

    return (
        <div>
            {content &&
                content.map((contentItem, itemIdx) => {
                    return renderPost(contentItem as BlogPagePreview, itemIdx);
                })}

            {/* {blogFormShow && (
                <div className={styles.subform}>
                    <BlogSubscriptionForm
                        headline={
                            form_headline?.value ? form_headline.value : ''
                        }
                        formConfirmationMessage={
                            form_confirmation_message? form_confirmation_message?.value
                                : ''
                        }
                        cta={
                            submit_cta_label?.value
                                ? submit_cta_label?.value
                                : ''
                        }
                        nameLabel={
                            full_name_field ? full_name_field?.value : ''
                        }
                        emailAddressLabel={
                            email_address_field
                                ? email_address_field?.value
                                : ''
                        }
                        blogTopics={blog_topic.value}
                        interestedFieldLabel={
                            interested_in_field
                                ? interested_in_field?.value
                                : ''
                        }
                        topics={[]}
                    />
                </div>
            )} */}
        </div>
    );
};

export default BlogExploration;
